export default {
  'processPortal.title': 'Manage Process Portal',

  'processPortal.form.shortenedUrl': 'Shortened Url',
  'processPortal.form.openUrl': 'Open Url',
  'processPortal.form.shortCode': 'ShortCode',

  'processPortal.descriptionProcess': 'The processes that will appear in the portal',
  'processPortal.descriptionReport': 'The reports that will appear in the portal',
  'processPortal.descriptionPermission': 'Access permissions to the portal',
  'processPortal.descriptionList': 'The lists that will appear in the portal',
  'processPortal.descriptionEntity': 'The entities that will appear in the portal',
  'processPortal.descriptionMenu': 'Menu structure for the process portal',

  'processPortal.form.mainColor': 'Main Color',
  'processPortal.form.logoUrl': 'Logo (Url)',
  'processPortal.form.template': 'Template',
  'processPortal.form.loginSplashUrl': 'Login Splash (Url)',
  'processPortal.form.fontUrl': 'Font (Url)',
  'processPortal.form.iconLogoUrl': 'Icon (Url)',
  'processPortal.form.faviconUrl': 'Favicon (Url)',
  'processPortal.form.permissionsFiltersLogicalOperator': 'Permissions Filters Logical Operator',
  'processPortal.form.hideMenuItemHome': 'Hide Home menu item',
  'processPortal.form.hideMenuItemTasks': 'Hide Tasks menu item',
  'processPortal.form.hideMenuItemRequests': 'Hide Requests menu item',

  'processPortal.menu.customList': 'List',
  'processPortal.menu.customLists': 'All Lists',
  'processPortal.menu.dynamicEntity': 'Dynamic Entity',
  'processPortal.menu.dynamicEntities': 'All Dynamic Entities',
  'processPortal.menu.report': 'Report',
  'processPortal.menu.reports': 'All Reports',
  'processPortal.menu.process': 'Process',
  'processPortal.menu.processes': 'All Processes',
  'processPortal.menu.link': 'Link',
  'processPortal.menu.subMenu': 'Dropdown Menu',
  'processPortal.menu.embedHtml': 'Embedded HTML',
  'processPortal.menu.renderTemplate': 'Render Template',
  'processPortal.menu.parentSubMenu': 'Parent Sub Menu',
  'processPortal.menu.htmlFile': 'HTML File',
  'processPortal.menu.templateLink': 'Template URL',
  'processPortal.menu.preview': 'Preview',

  'processPortal.action.generatePublicUrl': 'Generate Public URL',
  'processPortal.action.deactivatePublicUrl': 'Deactivate Public URL',
};
